import { render, staticRenderFns } from "./PricingPlanList.vue?vue&type=template&id=51523334&"
import script from "./PricingPlanList.vue?vue&type=script&lang=js&"
export * from "./PricingPlanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports